var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setSuccessMessage } from '@popup/multichain/actions/message.actions';
import { goBack } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent from 'src/common-ui/button/button.component';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const Analytics = ({ setSuccessMessage, goBack, setTitleContainerProperties, }) => {
    const [allowGoogleAnalytics, setAllowGoogleAnalytics] = useState(false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_analytics',
            isBackButtonEnabled: true,
        });
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        const analytics = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ANALYTICS_SETTINGS);
        setAllowGoogleAnalytics(analytics ? analytics.allowGoogleAnalytics : false);
    });
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        // AnalyticsUtils.saveSettings({
        //   allowGoogleAnalytics: allowGoogleAnalytics,
        // } as AnalyticsSettings);
        setSuccessMessage('popup_html_save_successful');
        if (allowGoogleAnalytics) {
            // AnalyticsUtils.initializeGoogleAnalytics();
        }
        goBack();
    });
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_ANALYTICS}-page`, className: "analytics-settings-page" },
        React.createElement("div", { className: "fields" },
            React.createElement(CheckboxPanelComponent, { dataTestId: `checkbox-allow-ga`, title: "popup_html_analytics_allow_ga", hint: "popup_html_analytics_message", checked: allowGoogleAnalytics, onChange: () => {
                    setAllowGoogleAnalytics(!allowGoogleAnalytics);
                } })),
        React.createElement(ButtonComponent, { dataTestId: "button-save", label: 'popup_html_save', onClick: () => save() })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {
    setSuccessMessage,
    goBack,
    setTitleContainerProperties,
});
export const AnalyticsComponent = connector(Analytics);
